<template>
  <div class="eliminate-question-view">
    <!-- <div class="question-desc-view">{{questioninfo.desc}}</div> -->
    <div class="eliminate-question-info-view">
      <div class="eliminate-question-content-info-view"
           v-if="questioninfo.contentsimg&&questioninfo.contentsimg.length>0">
        <div class="el-left-btn" v-if="localtoppage>1" @click="prelot"></div>
        <template v-for="(content,index) in questioninfo.contentsimg"
                  v-if="index<5*localtoppage&&index>=(localtoppage-1)*5">
          <div class="eliminate-select-contentimg-view"
               :class='content.isChecked?"isChecked":" contentitemt-view1 noChecked"'
               @click='selectcontentimg' :data-content="content"
               :data-index="index">
            <div class='select-img'
                 :style="'background-image:url('+baseurl+content.content+');background-size:100% 100%;'"></div>
          </div>
        </template>
        <div class="el-right-btn" v-if="localtoppage<toppages" @click="nextlot"></div>
      </div>
      <div class="eliminate-question-content-info-view" v-if="questioninfo.contents&&questioninfo.contents.length>0">
        <div class="el-left-btn" v-if="localbottompage>1" @click="prelob"></div>
        <template v-for="(content,index) in questioninfo.contents"
                  v-if="index<5*localbottompage&&index>=(localbottompage-1)*5">
          <div class="eliminate-select-content-view"
               :class='content.isChecked?"isChecked":" contentitemt-view1 noChecked"'
               @click='selectcontent' :data-content="content"
               :data-index="index">
            <div v-html="content.content"></div>
          </div>
        </template>
        <div class="el-right-btn" v-if="localbottompage<bottompages" @click="nextlob"></div>
      </div>
      <div class="show-toast-info-view" v-if="questioninfo.isfinish">
        <div class="show-toast-info"></div>
        <div class="show-toast-text">
          太棒啦 ！所有卡片已合成到下方的卡盒里。
        </div>
        <div class="show-toast-down"></div>
      </div>
    </div>
    <div class="eliminate-answer-bag-view" v-if="questioninfo.useroption.length>0">
      <div class="card-info-view" v-if="!showanswerdialog" @click="showAnswerDialog"></div>
      <div class="card-info-close-view" v-if="showanswerdialog" @click="closeAnswerDialog"></div>
      <div class="card-box-view"></div>
      <el-button class="card-clear-btn" v-if="showanswerdialog" @click="clearGroup">清空</el-button>
    </div>
    <EliminateCard v-if="showanswercard" :showanswerinfo="showanswerinfo"
                   @playaudioshow="playaudioshow"></EliminateCard>
    <audio ref="elimintmusic" controls="controls" style="display: none"
           preload="auto" @ended="musicend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
    <div class="show-answer-dialog-view" v-if="showanswerdialog">
      <div class="show-answer-dialog-left-btn" v-if="localanswerpages>1" @click="prevuser"></div>
      <div class="show-answer-dialog-right-btn" v-if="localanswerpages<useranswerpages" @click="nextuser"></div>
      <div class="show-answer-dialog-content-view">
        <template v-for="(item,index) in questioninfo.useroption">
          <EliminateCard :showanswerinfo="item"
                         @playaudioshow="playaudioshow" :showanswer="'showanswer1'"
                         v-if="index<4*localanswerpages&&index>=(localanswerpages-1)*4"></EliminateCard>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import Apis from "@/api"
  import apiUtil from "@/api/apiUtils"

  import Vue from 'vue';

  export default {
    name: "eliminatequestion",
    data() {
      return {
        questioninfo: {
          contents: [],
          contentsimg: []
        },
        toppages: 1,
        bottompages: 1,
        localtoppage: 1,
        localbottompage: 1,
        rightaudio: "../../../static/mp3/right3.mp3",
        wrongaudio: "../../../static/mp3/wrong3.mp3",
        baseurl: apiUtil.getBaseUrl(),
        useranswer: [],
        showanswercard: false,
        showanswerinfo: [],
        audiourl: "",
        showanswerdialog: false,
        useranswerpages: 1,
        localanswerpages: 1,
        showdesc: true,
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData();
      })
    },
    created() {
      // let _this = this;
      // _this.initData()
    },
    methods: {
      initData() {
        this.questioninfo = this.paraseData();
        console.log("@@", this.questioninfo)
      },
      paraseData() {
        var that = this;
        var questiondata = JSON.parse(JSON.stringify(this.questionData))
        if (!questiondata.useroption) {
          let contents = questiondata.content.replace(/\\n/g, "</br>").split("|");
          let contentimgs = questiondata.options.split("|")
          var answerslist = [];
          var answers = questiondata.answer.split("&")
          answers.forEach(answeritem => {
            var answer = answeritem.split("|")
            answerslist.push(answer)
          })
          var contentsinfo = that.randomSort(contents);
          var contentsimg = that.randomSort(contentimgs);
          var contentsimgs = [];
          var contentinfos = []
          contentsimg.forEach(item => {
            var contentimginfo = {
              content: item,
              isChecked: false
            }
            contentsimgs.push(contentimginfo)
          })
          contentsinfo.forEach(item => {
            var contentsinfo = {
              content: item,
              isChecked: false
            }
            contentinfos.push(contentsinfo)
          })
          questiondata.contents = contentinfos
          questiondata.contentsimg = contentsimgs;
          questiondata.answers = answerslist;
          this.toppages = parseInt(Math.ceil(questiondata.contentsimg.length / 5));
          this.bottompages = parseInt(Math.ceil(questiondata.contents.length / 5));
          questiondata.useroption = []
          return questiondata;
        } else {
          return questiondata;
        }
      },
      selectcontentimg(e) {
        var index = e.currentTarget.dataset.index;
        this.questioninfo.contentsimg.forEach((item, iindex) => {
          if (iindex == index) {
            item.isChecked = !item.isChecked
          } else {
            item.isChecked = false
          }
        })
        this.$forceUpdate()
        this.checkGroup()
      },
      checkGroup() {
        var questioninfo = this.questioninfo;
        var cimgindex = -1;
        var ctextindex = -1
        this.questioninfo.contentsimg.forEach((item, index) => {
          if (item.isChecked) {
            cimgindex = index
          }
        })
        this.questioninfo.contents.forEach((item, index) => {
          if (item.isChecked) {
            ctextindex = index
          }
        })
        if (cimgindex != -1 && ctextindex != -1) {
          var useranswer = [this.questioninfo.contents[ctextindex].content, this.questioninfo.contentsimg[cimgindex].content]
          questioninfo.useroption.push(useranswer)
          questioninfo.contentsimg.splice(cimgindex, 1)
          questioninfo.contents.splice(ctextindex, 1)
          this.questioninfo = questioninfo;
          this.showCard(useranswer);
          this.checkfinish();
        }
      },
      selectcontent(e) {
        var index = e.currentTarget.dataset.index;
        this.questioninfo.contents.forEach((item, iindex) => {
          if (iindex == index) {
            item.isChecked = !item.isChecked
          } else {
            item.isChecked = false
          }
        })
        this.$forceUpdate()
        this.checkGroup()

      },
      showCard(answer) {
        this.showanswerinfo = answer;
        this.showanswercard = true
        this.getAudioUrl(answer)
      },
      getAudioUrl(answer) {
        let that = this;
        var params = {
          'text': answer[0],
          'activity': ""
        }
        apiUtil.httpServer(Apis.getAudioData, params).then(res => {
          if (res.code == 200) {
            var audiourl = apiUtil.getBaseUrl() + res.data.amazon_url;
            this.$refs.elimintmusic.src = audiourl;
            if (that.$refs.elimintmusic.paused) {
              that.$refs.elimintmusic.play()
            }
          }
        })
      },
      musicend() {
        if (this.showanswercard) {
          setTimeout(() => {
            this.showanswercard = false
          }, 1000)
        }
      },
      playaudioshow(showanswerinfo) {
        this.getAudioUrl(showanswerinfo)
      },
      showAnswerDialog() {
        this.showanswerdialog = true;
        this.useranswerpages = parseInt(Math.ceil(this.questioninfo.useroption.length / 4));
      },
      closeAnswerDialog() {
        this.showanswerdialog = false;
      },
      clearGroup() {
        let that = this;
        var questiondata = this.questioninfo
        let contents = questiondata.content.replace(/\\n/g, "</br>").split("|");
        let contentimgs = questiondata.options.split("|")
        var answerslist = [];
        var answers = questiondata.answer.split("&")
        answers.forEach(answeritem => {
          var answer = answeritem.split("|")
          answerslist.push(answer)
        })
        var contentsinfo = that.randomSort(contents);
        var contentsimg = that.randomSort(contentimgs);
        var contentsimgs = [];
        var contentinfos = []
        contentsimg.forEach(item => {
          var contentimginfo = {
            content: item,
            isChecked: false
          }
          contentsimgs.push(contentimginfo)
        })
        contentsinfo.forEach(item => {
          var contentsinfo = {
            content: item,
            isChecked: false
          }
          contentinfos.push(contentsinfo)
        })
        questiondata.contents = contentinfos
        questiondata.contentsimg = contentsimgs;
        questiondata.answers = answerslist;
        this.toppages = parseInt(Math.ceil(questiondata.contentsimg.length / 8));
        this.bottompages = parseInt(Math.ceil(questiondata.contents.length / 8));
        questiondata.useroption = []
        questiondata.isfinish = false
        this.questioninfo = questiondata;
        this.$emit("questionfinish", this.questioninfo)
        this.closeAnswerDialog()
      },
      checkfinish() {
        if (!this.questioninfo.contents || this.questioninfo.contents.length == 0 || !this.questioninfo.contentsimg || this.questioninfo.contentsimg.length == 0) {
          this.questioninfo.isfinish = true;
          this.$emit("questionfinish", this.questioninfo)
        } else {
          var arry1 = document.getElementsByClassName("eliminate-select-contentimg-view")
          var arry = document.getElementsByClassName("eliminate-select-content-view")
          this.questioninfo.contents.forEach((item, index) => {
            this.addClass(arry[index], "noChecked")
            this.removeClass(arry[index], "isChecked")
          })
          this.questioninfo.contentsimg.forEach((item, index) => {
            this.addClass(arry1[index], "noChecked")
            this.removeClass(arry1[index], "isChecked")
          })
        }
      },
      playaudiotype(type) {
        var audiourl = "";
        if (type) {
          audiourl = this.rightaudio;
        } else {
          audiourl = this.wrongaudio;
        }
        this.$refs.elimintmusic.src = audiourl;
        if (this.$refs.elimintmusic.paused) {
          this.$refs.elimintmusic.play()
        } else {
          this.$refs.elimintmusic.pause()
        }
      },
      hasClass(elements, cName) {
        return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
      },
      addClass(elements, cName) {
        if (!this.hasClass(elements, cName)) {
          elements.className += " " + cName;
        }
        ;
      },
      removeClass(elements, cName) {
        if (this.hasClass(elements, cName)) {
          elements.className = elements.className.replace(new RegExp("(\\s|^)" + cName + "(\\s|$)"), " ");
        }
      },
      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.elimintmusic.src = audiourl;
        if (this.$refs.elimintmusic.paused) {
          this.$refs.elimintmusic.play()
          this.contentplay = true;
        }
      },
      prevuser() {
        this.localanswerpages -= 1;
        if (this.localanswerpages < 0) {
          this.localanswerpages = 0
        }
      },
      nextuser() {
        this.localanswerpages += 1;
        if (this.localanswerpages > this.useranswerpages) {
          this.localanswerpages = this.useranswerpages
        }
      },
      prelob() {
        this.localbottompage -= 1;
        if (this.localbottompage < 0) {
          this.localbottompage = 0
        }
      },
      nextlob() {
        this.localbottompage += 1;
        if (this.localbottompage > this.bottompages) {
          this.localbottompage = this.bottompages
        }
      },
      prelot() {
        this.localtoppage -= 1;
        if (this.localtoppage < 0) {
          this.localtoppage = 0
        }
      },
      nextlot() {
        this.localtoppage += 1;
        if (this.localtoppage > this.toppages) {
          this.localtoppage = this.toppages
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .eliminate-question-view {
    width 100%;
    height 100%;
    position relative;
  }

  .eliminate-question-info-view {
    display flex;
    width 90%;
    height 75%;
    margin auto;
    display flex;
    flex-direction column;
    justify-content space-around;
    align-items center;
    border-radius 12px;
    position relative;
  }

  .eliminate-question-content-info-view {
    width 100%;
    margin 10px auto;
    display flex;
    flex-direction row;
    align-items center;
    justify-content space-around;
  }

  .eliminate-select-content-view {
    width 210px;
    height 210px;
    background: #fff;
    border: 3px solid #131313;
    border-radius: 12px;
    display flex;
    align-items center;
    justify-content center;
    font-size 34px;
  }

  .eliminate-select-contentimg-view {
    width 210px;
    height 210px;
    background: #fff;
    border: 3px solid #131313;
    border-radius: 12px;
    display flex;
    align-items center;
    justify-content center;
    font-size 34px;
  }

  .noChecked {
    border: 3px solid #131313 !important;
  }

  .isChecked {
    border: 3px solid #5777FF !important;
  }

  .select-img {
    width 210px;
    height 210px;
    border-radius: 12px;
  }

  .el-left-btn {
    width 38px;
    height 38px;
    position absolute;
    float left;
    left -30px;
    background url("../../assets/img/el-left-img.png");
    background-size 100% 100%;
  }

  .el-right-btn {
    width 38px;
    height 38px;
    position absolute;
    float right;
    right -30px;
    background url("../../assets/img/el-right-img.png");
    background-size 100% 100%;
  }

  .eliminate-answer-bag-view {
    width 40%;
    margin auto;
    display flex;
    justify-content center;
    position absolute;
    bottom 10px;
    left 30%
    z-index 1501;
  }

  .show-toast-info-view {
    width 100%;
    height 100%;
    font-size 24px;
    color #FF9A09;
    display flex;
    justify-content center;
    align-items center;
    flex-direction column;
  }

  .card-info-view {
    background url("../../assets/img/card-info.png")
    background-size 100% 100%;
    width 121px;
    height 97px;
    position absolute;
    bottom 16px;
  }

  .card-info-close-view {
    background url("../../assets/img/answer-close-bg.png");
    width 112px;
    height 112px;
    background-size 100% 100%;
    position absolute;
    bottom 16px;
  }

  .card-clear-btn {
    position absolute;
    bottom 16px;
    right 0;
  }

  .card-box-view {
    width 150px;
    height 67px;
    background url("../../assets/img/card-box.png");
    background-size 100% 100%;
  }

  .show-toast-info {
    width 358px;
    height 288px;
    background url("../../assets/img/show-toast-info.png");
    background-size 100% 100%;
    margin-bottom 20px;
  }

  .show-toast-down {
    height 63px;
    width 45px;
    margin-top 26px;
    background url("../../assets/img/down-icon.png")
    background-size 100% 100%
  }


  .item-shake {
    border 6px solid red;
    -webkit-animation-name: shake-little;
    -ms-animation-name: shake-little;
    animation-name: shake-little;
    -webkit-animation-duration: 500ms;
    -ms-animation-duration: 500ms;
    animation-duration: 500ms;
    -webkit-animation-iteration-count: infinite;
    -ms-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-timing-function: ease-in-out;
    -ms-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
    -webkit-animation-play-state: running;
    -ms-animation-play-state: running;
    animation-play-state: running
  }

  .item-shake1 {
    border 6px solid red;
    -webkit-animation-name: shake-little;
    -ms-animation-name: shake-little;
    animation-name: shake-little;
    -webkit-animation-duration: 500ms;
    -ms-animation-duration: 500ms;
    animation-duration: 500ms;
    -webkit-animation-iteration-count: infinite;
    -ms-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    -webkit-animation-timing-function: ease-in-out;
    -ms-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
    -webkit-animation-play-state: running;
    -ms-animation-play-state: running;
    animation-play-state: running
  }

  .show-answer-dialog-view {
    width 100%;
    height 100%;
    position fixed;
    top 0;
    left 0;
    background #EBEAE6;
    z-index 1500;

    .show-answer-dialog-left-btn {
      background url("../../assets/img/el-left-img.png")
      background-size 100% 100%;
      width 76px;
      height 76px;
      position absolute;
      left 10px;
      top 45%;
    }

    .show-answer-dialog-right-btn {
      background url("../../assets/img/el-right-img.png")
      background-size 100% 100%;
      width 76px;
      height 76px;
      position absolute;
      right 10px;
      top 45%;
    }

    .show-answer-dialog-content-view {
      width 92%;
      height 70%;
      display flex;
      position absolute;
      left 4%;
      justify-content space-around;
      align-items center;
    }
  }

  @media screen and (max-width: 1600px) {
    .eliminate-question-info-view {
      top -6%;
    }

    .eliminate-select-contentimg-view {
      width 140px;
      height 140px;
      background: #fff;
      border: 3px solid #131313;
      border-radius: 12px;
      display flex;
      align-items center;
      justify-content center;
      font-size 24px;
    }

    .select-img {
      width 140px;
      height 140px;
    }

    .eliminate-select-content-view {
      width 140px;
      height 140px;
      background: #fff;
      border: 3px solid #131313;
      border-radius: 12px;
      display flex;
      align-items center;
      justify-content center;
      font-size 26px;
    }

    .show-toast-info {
      width 308px;
      height 228px;
      background url("../../assets/img/show-toast-info.png");
      background-size 100% 100%;
      margin-bottom 20px;
    }

    .eliminate-answer-bag-view {
      width 100%;
      display flex;
      justify-content center;
      position absolute;
      bottom 5px;
    }

    .show-toast-info-view {
      width 100%;
      height 100%;
      font-size 24px;
      color #FF9A09;
      display flex;
      justify-content center;
      align-items center;
      flex-direction column;
    }

    .card-info-view {
      background url("../../assets/img/card-info.png")
      background-size 100% 100%;
      width 102px;
      height 71px;
      position absolute;
      bottom 5px;
    }

    .card-info-close-view {
      background url("../../assets/img/answer-close-bg.png");
      width 80px;
      height 80px;
      background-size 100% 100%;
      position absolute;
      bottom 5px;
    }

    .card-box-view {
      width 126px;
      height 51px;
    }
  }

  @media screen and (max-width: 1366px) {
    .eliminate-question-info-view {
      display flex;
      width 88.54%;
      height 80%;
      background #F6C753;
      position relative;
      display flex;
      flex-direction column;
      justify-content space-around;
      align-items center;
      left 5.73%;
      top -15%;
      border-radius 12px;
    }

    .eliminate-select-contentimg-view {
      width 120px;
      height 120px;
      background: #fff;
      border: 3px solid #131313;
      border-radius: 12px;
      display flex;
      align-items center;
      justify-content center;
      font-size 20px;
    }

    .select-img {
      width 120px;
      height 120px;
    }

    .eliminate-select-content-view {
      width 120px;
      height 120px;
      background: #fff;
      border: 3px solid #131313;
      border-radius: 12px;
      display flex;
      align-items center;
      justify-content center;
      font-size 26px;
    }

    .show-toast-info {
      width 308px;
      height 228px;
      background url("../../assets/img/show-toast-info.png");
      background-size 100% 100%;
      margin-bottom 20px;
    }

    .eliminate-answer-bag-view {
      width 100%;
      display flex;
      justify-content center;
      position absolute;
      bottom 5px;
    }

    .show-toast-info-view {
      width 100%;
      height 100%;
      font-size 24px;
      color #FF9A09;
      display flex;
      justify-content center;
      align-items center;
      flex-direction column;
    }

    .card-info-view {
      background url("../../assets/img/card-info.png")
      background-size 100% 100%;
      width 102px;
      height 71px;
      position absolute;
      bottom 5px;
    }

    .card-info-close-view {
      background url("../../assets/img/answer-close-bg.png");
      width 80px;
      height 80px;
      background-size 100% 100%;
      position absolute;
      bottom 5px;
    }

    .card-box-view {
      width 126px;
      height 51px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/eliminatequestion.vue